import { LipstickType } from "./v1";

export const lipstickTypeOptions = Object.entries(LipstickType)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
